import { IUser } from 'src/utils/interfaces/user';
import { PaymentDataResponse } from 'src/services/models/payment.service';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import './style.scss';
interface IProps {
    data: PaymentDataResponse;
}
const ViewInformation = ({ data }: IProps) => {
    const { payments, paymentAccountEnumToUi } = useLocalization();
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    function getCity(paymentData: PaymentDataResponse) {
        const city = paymentData.accountDetail.address.City ?? '';
        const zipCode = paymentData.accountDetail.address.PostalCode ?? '';

        return `${city ? city + ', ' : city} ${zipCode}`;
    }
    return (
        <section className='c-form-section payment-account-info'>
            <div className='c-form-section__content'>
                <div className='title'>
                    <h6>
                        <span className='c-section-heading__title-text u-mr-xxsmall'>
                            {payments.PAYMENT_INFORMATION_ACCOUNTINFOLABEL}
                        </span>
                    </h6>
                </div>
                <div className='o-fieldset__row u-mt-small u-mb-small'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/2  u-1/1@l'>
                            <div className='field-show'>
                                <span className='label'>
                                    {
                                        payments.PAYMENT_INFORMATION_ACCOUNTNUMBERLABEL
                                    }
                                </span>
                                <span className='value'>
                                    {data.accountDetail.accountNumber}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {
                                        payments.PAYMENT_INFORMATION_ACCOUNTTYPELABEL
                                    }
                                </span>
                                <span className='value'>
                                    {
                                        paymentAccountEnumToUi[
                                            data.accountDetail.accountType
                                        ]
                                    }
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {
                                        payments.PAYMENT_INFORMATION_VEHICLEIDLABEL
                                    }
                                </span>
                                <span className='value'>
                                    {data.accountDetail.vin}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {payments.PAYMENT_INFORMATION_VEHICLEMAKEL}
                                </span>
                                <span className='value'>
                                    {data.accountDetail.vehicleMake}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {payments.PAYMENT_INFORMATION_VEHICLEMODEL}
                                </span>
                                <span className='value'>
                                    {data.accountDetail.vehicleModel}
                                </span>
                            </div>
                        </div>
                        <div className='o-layout__item  u-1/2  u-1/1@l'>
                            <div className='field-show'>
                                <span className='label'>
                                    {
                                        payments.PAYMENT_INFORMATION_CUSTOMERNAMELABEL
                                    }
                                </span>
                                <span className='value'>
                                    {data.accountDetail.customerName}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {payments.PAYMENT_INFORMATION_ADDRESSLABEL}
                                </span>
                                <span className='value'>
                                    {data.accountDetail.address.AddressLine1}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {payments.PAYMENT_INFORMATION_LOCATIONLABEL}
                                </span>
                                <span className='value'>{getCity(data)}</span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {payments.PAYMENT_INFORMATION_PROVINCELABEL}
                                </span>
                                <span className='value'>
                                    {data.accountDetail.address.StateOrProvince}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {
                                        payments.PAYMENT_INFORMATION_DEALERNUMLABEL
                                    }
                                </span>
                                <span className='value'>
                                    {dealerDataInfo?.dealer.dealerName}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ViewInformation;
